export default __webpack_public_path__ + "static/media/astro-head.0cca8a1c.svg";